import { Component, computed, input, output } from '@angular/core';

import {
  DateRange,
  DateRangeComponent,
  FilterButtonComponent,
  RefreshButtonComponent,
  ViewMode,
  ViewToggleComponent,
} from '@sandbox-platform/shared-ui';

import {
  CommissionInvoiceListFilters,
  defaultInvoiceListFilters,
} from '../../../../types/commission-invoice.types';

@Component({
  standalone: true,
  imports: [
    DateRangeComponent,
    FilterButtonComponent,
    RefreshButtonComponent,
    ViewToggleComponent,
  ],
  selector: 'lib-commission-invoice-search-filter',
  template: `
    <div class="flex flex-col justify-between gap-3 lg:flex-row">
      <div
        class="flex flex-col items-stretch gap-3 md:flex-row md:flex-wrap md:items-center"
      >
        <lib-date-range
          [dateRange]="dateRange()"
          (fromDateChange)="fromDateChange.emit($event)"
          (toDateChange)="toDateChange.emit($event)"
        />

        <div class="flex items-center gap-2">
          <lib-refresh-button
            [showText]="false"
            [disabled]="refreshDisabled()"
            (refreshClick)="refresh.emit()"
          />
        </div>
      </div>

      <div class="flex flex-col gap-4 md:flex-row">
        <shared-view-toggle
          [currentView]="currentView()"
          (viewChange)="viewChange.emit($event)"
        />

        <lib-filter-button
          [hasActiveFilters]="hasAdvancedFilters()"
          (buttonClick)="filterDialogOpen.emit()"
        />
      </div>
    </div>
  `,
})
export class CommissionInvoiceSearchFilterComponent {
  dateRange = input<DateRange>({ from: null, to: null });
  filters = input<CommissionInvoiceListFilters>(defaultInvoiceListFilters());
  currentView = input<ViewMode>('table');
  refreshDisabled = input<boolean>(false);

  fromDateChange = output<Event>();
  toDateChange = output<Event>();
  filterDialogOpen = output<void>();
  viewChange = output<ViewMode>();
  refresh = output<void>();

  protected readonly hasAdvancedFilters = computed(() => {
    const filters = this.filters();
    return (
      filters.status !== 'all' ||
      filters.payeeType !== 'all' ||
      !!filters.payeeOrganization ||
      !!filters.payerOrganization
    );
  });
}
